import { useCallback, useEffect, useRef, useState } from 'react';

const COPIED_DURATION_MS = 2000;

async function copyToClipboard(text: string): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        return false;
    }
}

export function useCopyToClipboard() {
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const copy = useCallback(async (text: string): Promise<boolean> => {
        const ok = await copyToClipboard(text);
        if (ok) {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            setCopied(true);
            timeoutRef.current = setTimeout(() => {
                setCopied(false);
                timeoutRef.current = null;
            }, COPIED_DURATION_MS);
        }
        return ok;
    }, []);

    useEffect(
        () => () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        },
        []
    );

    return { copy, copied };
}
